// IA-1 (editor de descripción enriquecido): saneador propio de la descripción larga. Lista blanca
// SUPERSET de la del saneador de la IA (backend `limpiarHtmlDescripcion`: p, strong, ul, li, h3) con
// em, ol, a. Convierte las salidas típicas de execCommand/Word/web (b→strong, i→em, div→p), DESENVUELVE
// lo no permitido conservando su texto, y en <a> deja solo un href de esquema seguro. Puro y testeable.

const TAGS_OK = new Set(['P', 'STRONG', 'EM', 'UL', 'OL', 'LI', 'H3', 'A']);
const RENOMBRA = { B: 'STRONG', I: 'EM', DIV: 'P' }; // normalizaciones comunes de execCommand / Word / web
const BLOQUES = new Set(['P', 'H3', 'LI']); // un bloque vacío (sin texto ni hijos útiles) se descarta

function escapar(t) {
  return String(t || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function escaparAttr(t) {
  return escapar(t).replace(/"/g, '&quot;');
}

// href: solo http(s), mailto, relativo (/...) o ancla (#...). javascript:, data:, etc. se caen.
function limpiarHref(href) {
  const h = String(href || '').trim();
  if (/^(https?:|mailto:)/i.test(h)) return h;
  if (/^[/#]/.test(h)) return h;
  return '';
}

function serializarHijos(node) {
  let out = '';
  node.childNodes.forEach((n) => { out += serializar(n); });
  return out;
}

function serializar(node) {
  if (node.nodeType === 3) return escapar(node.textContent); // texto
  if (node.nodeType !== 1) return '';                        // comentarios, etc.
  let tag = node.tagName.toUpperCase();
  tag = RENOMBRA[tag] || tag;
  const dentro = serializarHijos(node);
  if (!TAGS_OK.has(tag)) return dentro; // desenvuelve: conserva el contenido, descarta la etiqueta
  if (tag === 'A') {
    const href = limpiarHref(node.getAttribute && node.getAttribute('href'));
    if (!href) return dentro; // enlace sin destino seguro → queda el texto
    return `<a href="${escaparAttr(href)}">${dentro}</a>`;
  }
  if (BLOQUES.has(tag) && !dentro.trim()) return '';
  const t = tag.toLowerCase();
  return `<${t}>${dentro}</${t}>`;
}

// Devuelve HTML limpio con SOLO la lista blanca. En un entorno sin DOMParser devuelve texto escapado.
export function sanearHtmlDescripcion(html) {
  if (!html) return '';
  if (typeof DOMParser === 'undefined') return escapar(String(html).replace(/<[^>]+>/g, ''));
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  return serializarHijos(doc.body).trim();
}

// Qué insertar al PEGAR: si viene HTML (Word/web) se sanea a la lista blanca; si solo hay texto plano
// se escapa (los saltos de línea se vuelven <br> para no perder la separación visual).
export function htmlDesdePegado({ html, texto } = {}) {
  if (html && html.trim()) return sanearHtmlDescripcion(html);
  const t = String(texto || '');
  if (!t) return '';
  return escapar(t).replace(/\r?\n/g, '<br>');
}

export const TAGS_PERMITIDOS = Array.from(TAGS_OK).map((t) => t.toLowerCase());
